import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import Layout from '../_layout/index';
import MainWrapper from './MainWrapper';

import Dashboard from '../../pages/dashboard/DefaultDashboard';
import Sales from '../../pages/sales/Sales';
import Providers from '../../pages/providers/Providers';
import SalesItem from '../../pages/sales/SalesItem';
import Customers from '../../pages/customers/Customers';
import AutoCustomers from '../../pages/auto_customers/AutoCustomers';
import ChangeSIM from '../../pages/change_sim/ChangeSIM'
import Prize from '../../pages/prize/Prize';
import UserHistory from '../../pages/users_history/UserHistory';
import Settings from '../../pages/settings/Settings'
import ErrorPage from '../../pages/error/ErrorPage';
import Orders from '../../pages/orders/Orders'
import Equipments from '../../pages/equipments/Equipments'
import Tasks from '../../pages/tasks/Tasks'
import ManagersStats from "../../pages/managers_stats/ManagersStats";
import SalesStats from "../../pages/sales_stats/SalesStats";
import DeletedDeals from "../../pages/deleted_deals/DeletedDeals"
import * as http from "../../modules/http";


/*const Pages = () => (
  <Switch>

  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/pages" component={Pages} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/log_in" component={LogIn} />
        <Route path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;*/

class Router extends Component {

    constructor(props) {
        super(props);
        /*this.state = {
            currentPage: ''
        };*/

        this.prevPage = '';
    }

    render() {

        let content;
        if (this.props.hasError) {
            content = wrappedRoutesError;
        } else {
            if (this.props.isAdmin) {
                content = wrappedAdmin;
            }
            else if (this.props.isManager) {
                content = wrappedManager;
            }
            else {
                content = wrappedRoutes;
            }
        }

        //console.log(window.location.pathname + "; prev = " + this.prevPage);

        if (this.prevPage === '/customers') {

            //console.log("Clear")
            http.postToServer(
                'customers/cancel_edit_all?storeId=' + this.props.userData.data.id,
                {},
                (response) => {
                    //console.log(response.data);
                    //this.setState({now_handle_by: response.data[0].now_handle_by})
                },
                (response) => {
                    //console.log('error ' + response.data);
                    //this.setState({errorText: response.data.message})
                }
            );
        }

        this.prevPage = window.location.pathname;

        return (
            <MainWrapper>
                <main>
                    <Switch>
                        <Redirect from="/" exact to="/dashboard"/>
                        <Route path='/' component={content}/>
                    </Switch>
                </main>
            </MainWrapper>
        );
    }
}


const wrappedRoutesError = () => (
    <div>
        <Layout/>
        <div className='container__wrap'>

            <ErrorPage/>

        </div>
    </div>
);

const wrappedManager = () => {
    return (
        <div>
            <Layout/>
            <div className='container__wrap'>
                <Route path='/dashboard' component={Dashboard}/>
                <Route exact path='/sales' component={Sales}/>
                <Route exact path='/sales/:id' component={SalesItem}/>
                <Route exact path='/sales/2/:id' component={SalesItem}/>
                <Route exact path='/sales/3/:id' component={SalesItem}/>
                <Route exact path='/providers' component={Providers}/>
                <Route path='/customers' component={Customers}/>
                <Route path='/change_sim' component={ChangeSIM}/>
                <Route path='/orders' component={Orders}/>
                <Route path='/tasks' component={Tasks}/>
                <Route path='/prize' component={Prize}/>
                <Route path='/managers_stats' component={ManagersStats}/>
                <Route path='/equipment' component={Equipments}/>
            </div>
        </div>
    )
};

const wrappedRoutes = () => {
    return (
        <div>
            <Layout/>
            <div className='container__wrap'>
                <Route path='/dashboard' component={Dashboard}/>
                <Route exact path='/sales' component={Sales}/>
                <Route exact path='/sales/:id' component={SalesItem}/>
                <Route exact path='/sales/2/:id' component={SalesItem}/>
                <Route exact path='/sales/3/:id' component={SalesItem}/>
                <Route exact path='/providers' component={Providers}/>
                <Route path='/customers' component={Customers}/>
                <Route path='/change_sim' component={ChangeSIM}/>
                <Route path='/orders' component={Orders}/>
                <Route path='/equipment' component={Equipments}/>
            </div>
        </div>
    )
};

const wrappedAdmin = () => {

    return (

        <div>
            <Layout/>
            <div className='container__wrap'>
                <Route path='/dashboard' component={Dashboard}/>
                <Route exact path='/sales' component={Sales}/>
                <Route exact path='/sales/:id' component={SalesItem}/>
                <Route exact path='/sales/2/:id' component={SalesItem}/>
                <Route exact path='/sales/3/:id' component={SalesItem}/>
                <Route exact path='/providers' component={Providers}/>
                <Route path='/customers' component={Customers}/>
                <Route path='/change_sim' component={ChangeSIM}/>
                <Route path='/settings' component={Settings}/>
                <Route path='/orders' component={Orders}/>
                <Route path='/equipment' component={Equipments}/>
                <Route path='/tasks' component={Tasks}/>
                <Route path='/managers_stats' component={ManagersStats}/>
                <Route path='/sales_stats' component={SalesStats}/>
                <Route path='/deleted_deals' component={DeletedDeals}/>
                <Route path='/prize' component={Prize}/>
                <Route path='/users_history' component={UserHistory}/>
                <Route path='/auto_stat' component={AutoCustomers}/>
            </div>
        </div>
    )
};


export default Router;

